<main id="main">
  <div class="container animated fadeIn">
    <div class="row">
      <div class="col-lg-6 col-12 pt-5 pt-lg-0 order-2 order-lg-1 mt-5">
        <h1><strong>Don Emilio Construcciones</strong></h1>
        <h2>Somos tu mejor opcion a la hora de comprar tu lote en San Juan, Argentina</h2>
        <a href="/services" class="btn mt-3 text-white" style="background: #098f43">Conozca nuestros lotes</a>
      </div>
      <div class="col-lg-6 col-12 hero-img mb-5">
        <img src="assets/img/montaña.png" class="img-fluid animated mb-2">
      </div>
    </div>
  </div>
</main>
